var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseHeading',{staticClass:"title",attrs:{"level":2}},[_vm._v(" The page timed out while loading ")])}
var staticRenderFns = []

export { render, staticRenderFns }